<div class="container-fluid">
    <div class="invoiceWrapper">
        <div class="row">
            <div class="col-lg-1"> </div>
            <div class="col-lg-10">
                <div class="card">
                    <div class="card-body">
                        <div class="headerWrapper">
                            <h4> Cities</h4>
                            <div class="buttonWrapper">
                                <button *ngIf="addPermission === true" class="btn btn-success btn-sm" mat-raised-button (click)="openDialog()"> <i class="fa fa-plus" aria-hidden="true" ></i>ADD NEW</button>
                                <button *ngIf="editPermission === true" class="btn btn-warning btn-sm" (click)="editDialog(selectedIndex)"> <i class="fa fa-pencil-square-o"
                                        aria-hidden="true"></i>EDIT</button>
                                <button *ngIf="deletePermission === true" class="btn btn-danger btn-sm" (click)="deleteDialog(selectedIndex)"><i class="fa fa-trash" aria-hidden="true"></i>DELETE</button>
                            </div>

                        </div>
                        <div class="customModal">
                        </div>
                        <table class="table table-bordered" *ngIf="viewPermission === true">
                            <thead>
                                <tr>
                                    <th scope="col">Region</th>
                                    <th scope="col">Country</th>
                                    <th scope="col">City</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr rowspan="" *ngFor="let in of locations | slice: 0:10| paginate: { id: 'stockPageId', itemsPerPage: per_page, currentPage: current_page, totalItems: total_count}; let i = index " (click)="selectRow(i)" [ngClass]="{'sel': i === selectedIndex }" (dblclick)="editDialog(selectedIndex)" style="height: 36px;">
                                    <!-- <th scope="row">{{in.id}}</th> -->

                                <td>{{in.region_name}}</td>
                                <td>{{in.country_name}}</td>
                                <td>{{in.name}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="footerWrapper row">
                            <div class="col-lg-7 col-md-12 col-sm-12">
                                <div class="input-group">
                                    <select name="searchBy" [(ngModel)]="searchBy" data-show-content="true" class="form-control border" (change)="getSearchValue()">
                                        <option name="cityNoName" value="0"> Search by City Name</option>
                                        <option name="regionNoName" value="1"> Search by Region Name</option>
                                        <option name="countryNoName" value="2"> Search by Country Name</option>
                                    </select>

                                    <input type="text" placeholder="Search" class="form-control" name="searchTxt" [(ngModel)]="searchTxt" [placeholder]="placeHolder">

                                    <span class="input-group-text" (click)="doSearch()">
                                        <i class="fa fa-search" aria-hidden="true"></i>
                                    </span>
                                    <span class="input-group-text" (click)="doRefresh()">
                                        <i class="fa fa-refresh" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-12 col-sm-12">
                                <app-common-page [id]="stockPageId" (pageChange)="doPaginate($event)">
                                </app-common-page>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-1"> </div>

        </div>


    </div>


</div>
